import { FieldValidator, useField } from 'formik'
import { ReactElement, useMemo } from 'react'

interface FormikError {
  message: ReactElement
}

export function useFormikError(name: string, validate: FieldValidator | undefined): FormikError | undefined {
  const [, meta] = useField({ name, validate })

  const message = <div>{meta.error}</div>

  const error = useMemo(
    () => ({
      message
    }),
    [message]
  )

  if (!meta.error || !meta.touched) {
    return
  }

  return error
}
